import { render, staticRenderFns } from "./InformativaRegistrazioneCittadini.vue?vue&type=template&id=3d661b9f&"
import script from "./InformativaRegistrazioneCittadini.vue?vue&type=script&lang=js&"
export * from "./InformativaRegistrazioneCittadini.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports